module.exports = __webpack_public_path__ + "img/hero.309a91ba.png";